function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRotation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.534,
    height: 12,
    viewBox: "0 0 11.534 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "7t3gsjky3a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 29512",
    d: "M238.125-813.232a1.384 1.384 0 0 0 1.384-1.384 1.384 1.384 0 0 0-1.384-1.384 1.384 1.384 0 0 0-1.384 1.384 1.384 1.384 0 0 0 1.384 1.384z",
    transform: "translate(-236.741 816)",
    style: {
      clipRule: "evenodd",
      fill: "#66676b"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ka081wgbcb"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 29511",
    d: "M192-837.939h82.252V-850H192z",
    transform: "translate(-192 850)",
    style: {
      fill: "#66676b"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 178022"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Union 89",
    d: "M6.669 3.34a5.2 5.2 0 0 0 1.694-.616l.474.816a6.094 6.094 0 0 1-2 .729zm-3.97.2.471-.818a5.159 5.159 0 0 0 1.7.617l-.17.93a6.079 6.079 0 0 1-2-.729zm7.624-1.492-.576-.483a5.259 5.259 0 0 0 .9-1.565l.887.324a6.139 6.139 0 0 1-1.064 1.848zM0 .324.887 0a5.207 5.207 0 0 0 .9 1.565l-.724.607A6.116 6.116 0 0 1 0 .324z",
    transform: "translate(0 7.731)",
    style: {
      fill: "#66676b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 29509",
    d: "M7.919 4.041c-.073.016-.145.037-.217.056-.1.026-.2.053-.292.084-.076.025-.15.054-.224.082s-.177.07-.263.108-.147.069-.22.106a5.578 5.578 0 0 0-.452.259c-.068.044-.153.1-.227.157s-.13.094-.192.144-.146.123-.217.187-.114.1-.168.153c-.077.075-.149.156-.221.236A5.049 5.049 0 0 0 3.923 9H3a5.968 5.968 0 0 1 1.407-3.855c.042-.05.091-.1.135-.144.085-.095.169-.189.26-.278.064-.063.132-.121.2-.18.084-.076.169-.152.257-.223.073-.059.15-.114.226-.169s.178-.128.27-.187.163-.1.246-.149a6.155 6.155 0 0 1 .859-.411c.087-.033.174-.067.264-.1a5.94 5.94 0 0 1 .346-.1c.085-.023.169-.047.256-.066.134-.029.271-.05.408-.07.073-.011.145-.025.219-.034a5.967 5.967 0 0 1 5.258 2.136V3.461h.923v3.691h-3.691v-.923h2.394A5.057 5.057 0 0 0 9 3.922a5.126 5.126 0 0 0-.549.031c-.063.007-.124.019-.186.028-.117.019-.233.035-.346.06z",
    transform: "translate(-3 -3)",
    style: {
      fill: "#66676b"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 178021",
    transform: "translate(4.614 4.614)",
    style: {
      clipPath: "url(#7t3gsjky3a)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 178020",
    transform: "translate(-8.846 -6.723)",
    style: {
      clipPath: "url(#ka081wgbcb)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 29510",
    d: "M231.741-821h4.745v4.745h-4.745z",
    transform: "translate(-223.883 826.734)",
    style: {
      fill: "#66676b"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotation);
export default __webpack_public_path__ + "static/media/rotation.435a0a4b81883d90f9455476f95055ea.svg";
export { ForwardRef as ReactComponent };